import React from 'react'
import Tab from '@react/react-spectrum/TabList/js/Tab'
import TabList from '@react/react-spectrum/TabList/js/TabList'
import Button from '@react/react-spectrum/Button'
import { Link } from "react-router-dom"
import cloud from "../../Imgs/creativecloudlogo.png"

export default function Header() {
    return (
        <div className="header">
            <TabList defaultSelectedIndex={4} id="tabHeader">
                <Tab id="firstTab" ><span id="firstTabStyle">
                    <Link to="/">
                        <img src={cloud} />
                    </Link>
                </span>
                </Tab>
            </TabList>
            <TabList id="paddingRight" defaultSelectedIndex={10} >
                <Tab id="signIn"> <Button>Sign In</Button></Tab>
                
            </TabList>
        </div>
    )
}